import * as React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const PageNavigations = (props) => {
  if (props.id) {
    return (
      <div>
        <Row className="g-0">
          {}
          <Col lg={props.colLg} className={`${props.colClassName} mx-2`}>
            {props.listName ? (
              <Link className="nav-link" to="/">
                Home
              </Link>
            ) : (
              <Typography color="text.primary">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </Typography>
            )}
            {}
            <i
              className="fa-solid fa-chevron-right mx-1"
              style={{
                margin: "auto",

              }}
            ></i>
            {props.listName ? (
              props.viewName ? (
                <Link
                  className="nav-link"
                  underline="hover"
                  color="inherit"
                  to={props.listPath}
                >
                  {props.listName}
                </Link>
              ) : (
                <Typography color="text.primary">
                  <Link
                    className="nav-link"
                    underline="hover"
                    color="inherit"
                    to={props.listPath}
                  >
                    {props.listName}
                  </Link>
                </Typography>
              )
            ) : (
              ""
            )}

            <i
              className="fa-solid fa-chevron-right mx-1"
              style={{

                margin: "auto",
              }}
            ></i>

            {props.viewName ? (
              <Typography color="text.primary">
                <Link
                  className="nav-link"
                  underline="hover"
                  color="inherit"
                  to={props.viewPath}
                >
                  {props.viewName}
                </Link>
              </Typography>
            ) : (
              ""
            )}
          </Col>
          <Col lg={props.extrColumn} />
        </Row>
      </div>
    );
  } else {
    return (
      <div>
        <Row className="g-0">
          <Col lg={props.colLg} className={`${props.colClassName} mx-2`}>
            {props.listName ? (
              <Link className="nav-link" to="/">
                Home
              </Link>
            ) : (
              <Typography color="text.primary">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </Typography>
            )}

            <i
              className="fa-solid fa-chevron-right mx-1"
              style={{
                fontSize: "12px",
                margin: "auto",
              }}
            ></i>

            {props.listName ? (
              <Typography color="text.primary">
                <Link
                  className="nav-link"
                  underline="hover"
                  color="inherit"
                  to={props.listPath}
                >
                  {props.listName}
                </Link>
              </Typography>
            ) : (
              ""
            )}
          </Col>
          <Col lg={props.extrColumn} />
        </Row>
      </div>
    );
  }
};
export default PageNavigations;
